import { z } from 'zod'

import { ctaButtonBlockSchema } from './cta.schema'
import { faqBlockSchema } from './faq.schema'
import { galleryBlockSchema } from './gallery.schema'
import { fullWidthVideoBlockSchema, imageBlockSchema } from './image.schema'
import { quoteBlockSchema } from './quote.schema'
import { speakerBlockSchema } from './speaker.schema'
import { textBlockSchema } from './text.schema'

export const blockDefinitionSchema = z.discriminatedUnion('type', [
    textBlockSchema,
    quoteBlockSchema,
    faqBlockSchema,
    imageBlockSchema,
    galleryBlockSchema,
    fullWidthVideoBlockSchema,
    speakerBlockSchema,
    ctaButtonBlockSchema,
])

export type BlockDefinition = z.infer<typeof blockDefinitionSchema>

export const blockDefinitionArraySchema = z.array(blockDefinitionSchema)

export type BlockDefinitionArray = z.infer<typeof blockDefinitionArraySchema>
